import { useMutation } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { updateLoan } from '../service/loanService'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import { Loan } from '../types/Loan'

export const useUpdateLoan = () => {
  const companyId = useSelector(contextCompanyIdSelector)!

  return useMutation({
    mutationKey: ['budget', 'loan', 'update'],
    mutationFn: (data: Loan) => updateLoan(data, companyId, data.id)
  })
}
